import React, { Component } from 'react';
import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker,
	InfoWindow
} from "react-google-maps";



class BedrijvenSearchResultGoogleMaps extends Component {
	constructor() {
		super();
		this.state = {
			selectedMarker: null
		}
		this.showMarkers = this.showMarkers.bind(this);
		this.openInfo = this.openInfo.bind(this);
	}
	openInfo(i) {
		this.setState({ selectedMarker: i });
	}
	showMarkers() {
		let companies = this.props.companies
		return companies !== undefined ? companies.map((c, i) => {
			if (c.latitude !== null && c.longitude !== null)
				return <Marker onClick={() => this.openInfo(i)}
					key={i}
					position={{ lat: c.latitude, lng: c.longitude }}
					defaultAnimation={2}>
					{this.state.selectedMarker === i ? <InfoWindow ><div><div>{c.logo === "/companies/" ? "" : <img src={"/media/uploads/logo" + c.logo} alt={"Logo van " + c.name} className="img-responsive" style={{ display: "initial", maxHeight: "30px" }} />}</div><div>{c.name}</div><div>{c.city}</div><div><a href={"http://" + c.website} target="_blank">website</a></div></div></InfoWindow> : ""}</Marker>
		}) : null
	}

	render() {
		const MapWithAMarker =
			withScriptjs(
				withGoogleMap(props => <GoogleMap
					defaultZoom={8}
					defaultCenter={{ lat: 52.046415, lng: 4.482886 }}>
					{this.showMarkers()}
				</GoogleMap>
				));

		return (
			<div className="BedrijvenSearchResultGoogleMaps">
				<MapWithAMarker
					googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDq58BFMzXBAvzmhppkTYLaKalmedGePCU&v=3.exp&libraries=geometry,drawing,places"
					loadingElement={<div style={{ height: `100%` }} />}
					containerElement={<div style={{ height: `500px` }} />}
					mapElement={<div style={{ height: `100%` }} />}
				/>
			</div>
		);
	}
}

export default BedrijvenSearchResultGoogleMaps;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/BedrijvenSearchResultGoogleMaps.js